import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  EffectFade,
  Pagination,
  Navigation,
  Thumbs,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/autoplay";

const Swiperslider = ({
  children,
  spaceBetween,
  slidesPerView,
  navigation,
  pagination,
  timeDelay,
  centeredSlides,
  tabsliderperview,
  smallsliderperview,
  mobsliderperview,
  tabspaceBetween,
  loop,
}) => {
  const containerRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    const targetElement = containerRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (swiperInstance) {
          if (entry.intersectionRatio >= 0.5) {
            swiperInstance.autoplay?.start();
          } else {
            swiperInstance.autoplay?.stop();
          }
        }
      },
      {
        threshold: [0.5],
      }
    );

    if (targetElement) {
      observer.observe(targetElement);
    }

    return () => {
      if (targetElement) {
        observer.unobserve(targetElement);
      }
    };
  }, [swiperInstance]);

  const swiperModules = [Pagination, Navigation, Thumbs, Autoplay];
  if (slidesPerView === 1) {
    swiperModules.push(EffectFade);
  }

  return (
    <div ref={containerRef}>
      <Swiper
        onSwiper={setSwiperInstance}
        loop={loop}
        pagination={pagination}
        navigation={navigation}
        autoplay={{
          delay: timeDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }}
        effect={slidesPerView === 1 ? "fade" : "slide"}
        modules={swiperModules}
        centeredSlides={centeredSlides}
        className="h-100"
        breakpoints={{
          420: {
            slidesPerView: mobsliderperview,
          },
          640: {
            slidesPerView: smallsliderperview,
          },
          768: {
            slidesPerView: tabsliderperview,
            spaceBetween: tabspaceBetween,
          },
          1024: {
            slidesPerView: slidesPerView,
            spaceBetween: spaceBetween,
          },
        }}
      >
        {React.Children.map(children, (child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Swiperslider;
